import React, { Component } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { Menu, Icon, Dropdown } from 'semantic-ui-react';

class Pagination extends Component {
  constructor(props) {
    super(props);
    this.state = { pager: {}, itemsPerPage: this.props.itemsPerPage };
  }

  componentWillMount() {
    // set page if items array isn't empty
    if (this.props.items && this.props.items.length) {
      this.setPage(this.props.initialPage);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    // reset page if items array has changed
    if (this.props.items !== prevProps.items) {
      this.setPage(this.props.initialPage);
    }
  }

  setPage(page, itemsXPage) {
    const { items } = this.props;
    let pager = this.state.pager;

    //Limits for page and disable buttons
    if (page < 1 || page > pager.totalPages) {
      return;
    }
    // get new pager object for specified page
    pager = this.getPager(items.length, page, itemsXPage);
    // get new page of items from items array
    let pageOfItems = items.slice(pager.startIndex, pager.endIndex + 1);
    // update state
    this.setState({ pager: pager });
    // go to the top
    this.props.goToRef();
    // call change page function in parent component
    this.props.onChangePage(pageOfItems);
  }
  setItemsPerPage = (e, { value }) => {
    this.setPage(1, value);
    this.setState({ itemsPerPage: value });
    this.props.goToRef();
  };
  getPager(totalItems, currentPage, pageSize) {
    // default to first page
    currentPage = currentPage || 1;

    // default page size is 10
    pageSize = pageSize || 10;

    // calculate total pages
    let totalPages = Math.ceil(totalItems / pageSize);
    let startPage, endPage;
    if (totalPages <= 5) {
      // less than 10 total pages so show all
      startPage = 1;
      endPage = totalPages;
    } else {
      // more than 10 total pages so calculate start and end pages
      if (currentPage <= 3) {
        startPage = 1;
        endPage = 5;
      } else if (currentPage + 2 >= totalPages) {
        startPage = totalPages - 4;
        endPage = totalPages;
      } else {
        startPage = currentPage - 2;
        endPage = currentPage + 2;
      }
    }

    // calculate start and end item indexes
    let startIndex = (currentPage - 1) * pageSize;
    let endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1);

    // create an array of pages to ng-repeat in the pager control
    let pages = _.range(startPage, endPage + 1);

    // return object with all pager properties required by the view
    return {
      totalItems: totalItems,
      currentPage: currentPage,
      pageSize: pageSize,
      totalPages: totalPages,
      startPage: startPage,
      endPage: endPage,
      startIndex: startIndex,
      endIndex: endIndex,
      pages: pages
    };
  }

  render() {
    let { pager, itemsPerPage } = this.state;
    // if (!pager.pages || pager.pages.length <= 1) {
    //   // don't display pager if there is only 1 page
    //   return null;
    // }

    return (
      <div>
        <div>
          <Menu pagination compact>
            <Menu.Item
              as="a"
              icon
              className={pager.currentPage === 1 ? 'disabled' : ''}
              onClick={() => this.setPage(pager.currentPage - 1, itemsPerPage)}
            >
              <Icon name="left chevron" />
            </Menu.Item>

            {pager.pages.map((page, index) => (
              <Menu.Item
                as="a"
                key={index}
                className={pager.currentPage === page ? 'active' : ''}
                onClick={() => this.setPage(page, itemsPerPage)}
              >
                {page}
              </Menu.Item>
            ))}
            <Menu.Item
              as="a"
              icon
              className={
                pager.currentPage === pager.totalPages ? 'disabled' : ''
              }
              onClick={() => this.setPage(pager.currentPage + 1, itemsPerPage)}
            >
              <Icon name="right chevron" />
            </Menu.Item>
          </Menu>
        </div>
        <div style={{ paddingTop: '10px' }}>
          <Dropdown
            onChange={this.setItemsPerPage}
            options={this.props.options}
            placeholder="10 por página"
            compact
            selection
            value={itemsPerPage}
          />
        </div>
      </div>
    );
  }
}

Pagination.propTypes = {
  items: PropTypes.array.isRequired,
  onChangePage: PropTypes.func.isRequired
};

export default Pagination;
